//import { Configurations } from "./Configurations";
import jwtDecode from 'jwt-decode';

let _loggedUser;

class Usuario {

    static b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
    }

    static getDadosUsuario(token) {
        // const conf = new Configurations();
        // const localToken = window.localStorage.getItem(conf.tokenKey);
        // if (!token && !localToken) return undefined;

        if (!token) return undefined;

        // const _tokenParts = token.split('.'), //token? token.split('.') : localToken.split('.')
        //     _userData = JSON.parse(this.b64DecodeUnicode(_tokenParts[1]));

        // this.setLoggedUser = _userData;
        const _userData = jwtDecode(token);

        return _userData;
    }

    static get getLoggedUser() {
        return _loggedUser;
    }

    static set setLoggedUser(user) {
        _loggedUser = user;
    }
}

export default Usuario;